export default {
  nb: 'no-NO',
  no: 'no-NO',
  sv: 'sv-SE',
  da: 'da-DK',
  fi: 'fi-FI',
  en: 'en-US',
  mt: 'en-US',
  de: 'de-DE',
  fr: 'fr-FR',
  it: 'it-IT',
  es: 'es-ES',
  nl: 'nl-NL',
  pl: 'pl-PL',
  pt: 'pt-BR',
  ro: 'ro-RO',
  et: 'et-EE',
  lt: 'lt-LT',
  lv: 'lv-LV',
  hu: 'hu-HU',
  ru: 'ru-RU',
};
